import React from 'react';
import PropTypes from 'prop-types';

const OrderDetailLoading = (props) => {

    const {isLoading, message} = props;

    if (!isLoading) {
        return null;
    }

    return (
        <span className="padx2">
            {message}
            <br/>
        </span>

    );

};

OrderDetailLoading.propTypes = {
    isLoading: PropTypes.bool,
    message: PropTypes.string

};

export default OrderDetailLoading;



// WEBPACK FOOTER //
// ./src/components/work-order/OrderDetailLoading.js